/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

  export class SmartTilePropMultiSelect implements angular.IComponentOptions {
    templateUrl = "app/components/controls/smartCenterDesigner/propertyViews/smartTilePropMultiSelect.component.html";
    bindings: any = {
      prop: '=?',
      template: "@",
      selectionChanged: '&?',
      tile: '=?'
      //supportExclusion: '=?'
    }
    controller = class SmartTilePropMultiSelectController {
      static $inject = [
        "meevo.components.common.DataService"
      ];

      public prop: Meevo.Model.SmartTileMultiSelectParameter;
      public selectedItem: any;
      public selectedItems: any[] = [];
      public includedEmployees: Model.EnumDto[] = [];
      public selectionChanged: Function;
      public exclusionCriteria: any;
      public template: string;
      public tile: Meevo.Model.SmartCenterSmartTile;
      //public supportExclusion: boolean = true;

      constructor(protected dataService: Components.BaseClasses.IDataService) { }

      $onDestroy(): void {
        this.prop.selections = (this.selectedItems && this.selectedItems.length > 0) ? this.selectedItems : null;
      }

      $onInit(): void {
        if (this.prop && this.prop.multiSelectTemplateKey) {
          this.template = this.prop.multiSelectTemplateKey;
          this.selectedItems = _.map(this.prop.selections, s => {
            return {
              id: s.id,
              // TODO: Find a way to make this common with typeahead
              displayName: `${Meevo.Model.Guard.isSomething(s.shortcut) ? s.shortcut + ': ': ''}${Meevo.Model.Guard.isSomething(s.displayName) ? s.displayName : ''}`
            };
          });
        }
      }

      onSelectionChanged(): void {
          if (Model.Guard.isSomething(this.selectedItem)) {
            if(this.selectedItems.filter(item => item.id === this.selectedItem.id).length > 0) {
                this.selectedItem = undefined;
              return;
            }

          this.selectedItems.push(
          {
              id: this.selectedItem.id,
              // TODO: Find a way to make this common with typeahead
              displayName: `${Meevo.Model.Guard.isSomething(this.selectedItem.shortcut) ? this.selectedItem.shortcut + ': ' : ''}${Meevo.Model.Guard.isSomething(this.selectedItem.displayName) ? this.selectedItem.displayName : ''}`
                  });
          (<Meevo.Model.SmartTileMultiSelectParameter>this.tile.parsedParameters["multiSelectTemplateKey"]).selections = this.selectedItems;
          //if (this.supportExclusion)
          this.exclusionCriteria = { ExcludeIdList: _.pluck(this.selectedItems, 'id') };
          this.selectedItem = undefined;
          this.selectionChanged();
        }
      }

      removeSelectedItem(index: number): void {
        if (Model.Guard.isSomething(this.selectedItems)) {
          this.selectedItems.splice(index, 1);
          //if (this.supportExclusion)
          (<Meevo.Model.SmartTileMultiSelectParameter>this.tile.parsedParameters["multiSelectTemplateKey"]).selections = this.selectedItems;
          this.exclusionCriteria = (this.selectedItems && this.selectedItems.length > 0)
            ? { ExcludeIdList: _.pluck(this.selectedItems, 'id') } : null;
        }
      }
    }
  }

  angular.module("meevo.components.controls")
    .component("stpMultiSelect", new SmartTilePropMultiSelect());
}
